import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';

import * as actions from './redux/actions/index';
import AllListings from './components/AllListings';
import EditListing from './components/EditListing';
import getTheme from './theme';
import MenuBar from './components/MenuBar/MenuBar';
import User from './components/User'
import './App.css';

const useStyles = makeStyles((theme) => createStyles({
    mainContentWrapper: {
        background: theme.palette.background.default,
        bottom: 0,
        left: 0,
        overflowY: 'scroll',
        position:' fixed',
        right: 0,
        top: '60px',
        [theme.breakpoints.up('sm')]: {
            top: '80px',
        },
        [theme.breakpoints.up('md')]: {
            top: '100px',
        },
    },
}));

export default function App (props) {
    const user = useSelector(state => state.user);
    const showSnackbar = useSelector(state => state.snackbar.show);
    const showSnackbarMessage = useSelector(state => state.snackbar.message);
    const showSnackbarSeverity = useSelector(state => state.snackbar.severity);
    const dispatch = useDispatch();
    const location = useLocation();
    const classes = useStyles();
    const theme = user?.userData?.theme ? getTheme(user?.userData?.theme).theme : getTheme().theme
    const logo = user?.userData?.theme ? getTheme(user?.userData?.theme).logo : getTheme().logo

    return (
        <ThemeProvider theme={theme}>
            <MenuBar />
            <TransitionGroup>
                <CSSTransition
                    timeout={1000}
                    classNames={location.pathname.match(/\/listing\/\d*/) ? 'slide-right' : 'slide-left'}
                    in={true}
                    appear={true}
                    key={location.key}>
                    <Switch location={location}>
                        <Route exact path="/listing/:id">
                            <Box className={classes.mainContentWrapper}>
                                {user.isLoggedIn ? <EditListing /> : <Redirect to='/login'  /> }
                            </Box>
                        </Route>
                        <Route exact path="/">
                            <Box className={classes.mainContentWrapper}>
                                {user.isLoggedIn ? <AllListings /> : <User type="login" logo={logo}/> }
                            </Box>
                        </Route>
                        <Route exact path="/login">
                            <Box className={classes.mainContentWrapper}>
                                {user.isLoggedIn ? <Redirect to='/'  /> : <User type="login" logo={logo}/> }
                            </Box>
                        </Route>
                        <Route exact path="/register">
                            <Box className={classes.mainContentWrapper}>
                                <User type="register" logo={logo}/>
                            </Box>
                        </Route>
                        <Route exact path="/forgot-password">
                            <Box className={classes.mainContentWrapper}>
                                <User type="forgotPassword" logo={logo}/>
                            </Box>
                        </Route>
                    </Switch>
                </CSSTransition>
            </TransitionGroup>
            <Snackbar
                open={showSnackbar}
                autoHideDuration={5000}
                onClose={dispatch(actions.hideSnackbar())}>
                <Alert
                    onClose={dispatch(actions.hideSnackbar())}
                    severity={showSnackbarSeverity}
                    variant="filled">
                    {showSnackbarMessage}
                </Alert>
            </Snackbar>
        </ThemeProvider>
    );
}
